import React, { FC } from 'react';
import { useEditorContext } from '../../../../components/Editor/Context';
import cn from 'classnames';
import Delete from '../buttons/Delete';
import BlockBubbleMenu from '../../../../components/menus/BlockBubbleMenu';
import { DaGalleryOptions } from '../../gallery';
import {
  getExtensionOptions,
  shouldBlockMenuBeOpen,
} from '../../../../components/utils/tiptap';
import { isTouch } from '../../../../components/utils/browser';
import Layout from '../buttons/Layout';
import Edit from '../buttons/Edit';
import Settings from '../buttons/Settings';
import { EXTENSION_TYPE_NAME } from '../../constants';

export interface Props {
  scrollContainerRef?: React.RefObject<HTMLElement | null>;
}

const MenuButtons: FC<any> = ({ editor, forMobile = false }) => {
  const options: DaGalleryOptions = getExtensionOptions(
    editor,
    EXTENSION_TYPE_NAME
  );
  return (
    <div
      className={cn(!forMobile && 'ds-surface-tertiary')}
      style={{ maxWidth: '100vw', display: 'flex', flexWrap: 'wrap' }}
    >
      <Layout editor={editor} />
      <Edit editor={editor} />
      {options.canConfigure && <Settings editor={editor} />}
      <Delete editor={editor} />
    </div>
  );
};

const DaGalleryBubbleMenu: FC<Props> = ({ scrollContainerRef }) => {
  const editor = useEditorContext();

  if (!editor) {
    return null;
  }

  if (!editor?.isEditable || isTouch()) {
    return null;
  }

  const open = shouldBlockMenuBeOpen(editor, EXTENSION_TYPE_NAME);

  const options: DaGalleryOptions = getExtensionOptions(
    editor,
    EXTENSION_TYPE_NAME
  );
  let buttonCount = 4;
  if (!options.canConfigure) {
    buttonCount--;
  }

  return (
    <BlockBubbleMenu
      scrollContainerRef={scrollContainerRef}
      menuHeight={38}
      menuWidth={40 * buttonCount}
      editor={editor}
      open={open}
      childSelector="div"
    >
      <MenuButtons editor={editor} />
    </BlockBubbleMenu>
  );
};
DaGalleryBubbleMenu.displayName = 'DaGalleryBubbleMenu';

export default DaGalleryBubbleMenu;
export { MenuButtons };
